"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.use = exports.classnames = exports.bem = void 0;
const bem = (baseName, ...names) => {
    let className = baseName.concat(' ');
    names.forEach((name, idx) => {
        if (name)
            className += `${baseName}${name} `;
    });
    return className.trim();
};
exports.bem = bem;
const classnames = (...names) => {
    let className = '';
    names.forEach((name) => {
        if (name)
            className += `${name} `;
    });
    return className.trim();
};
exports.classnames = classnames;
/**
 * Shortens the syntax for deciding whether to include a class or not based on the prescence of a key
 */
const use = (key, value, defaultValue = null) => {
    if (key) {
        return typeof value === 'function' ? value() : value;
    }
    return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
};
exports.use = use;
//# sourceMappingURL=classNameBuilders.js.map